/**
 * Small helpers for reading Plone content values, each of which used to be
 * copy-pasted across the views and cards.
 */

/**
 * True when an image field actually carries a usable picture.
 *
 * Was defined verbatim in eight views (ExternalProject, Competition, Topic,
 * Robot, Event, Project, Thesis, Publication) - in ThesisView even inside
 * the component body, so it was rebuilt on every render.
 */
export const hasImage = (img) =>
  !!(
    img?.scales?.preview?.download ||
    img?.scales?.mini?.download ||
    img?.download
  );

/**
 * Relation fields normally hold objects, but a few legacy items still carry
 * a plain name string. Was defined identically inside CourseView, JobView
 * and ProjectView.
 */
export const normalizePerson = (person) => {
  if (!person) return null;
  if (typeof person === 'string') return { title: person };
  return person;
};

/**
 * Label of a vocabulary value. plone.restapi serializes a Choice field as
 * `{title, token}` on a full object but as the bare token in catalog
 * metadata, so both shapes turn up depending on whether the value came
 * from a view or from a listing result.
 *
 * Callers that want a missing value as `null` rather than `undefined`/`''`
 * keep writing `vocabTitle(x) || null` - that stays explicit at the call
 * site instead of becoming a second near-identical helper.
 */
export const vocabTitle = (value) => value?.title ?? value;
